import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/axios.js';

export function useWhatsAppEstado({ enabled = true, refetchInterval = 30_000 } = {}) {
  return useQuery({
    queryKey: ['whatsapp-estado'],
    queryFn: () => api.get('/whatsapp/estado').then((r) => r.data),
    enabled,
    refetchInterval,
    retry: false,
  });
}

export function useWhatsAppQr() {
  return useQuery({
    queryKey: ['whatsapp-qr'],
    queryFn: () => api.get('/whatsapp/qr').then((r) => r.data),
    enabled: false,   // se dispara manualmente con refetch()
    retry: false,
    staleTime: 0,
  });
}

export function useDesconectarWhatsApp() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.delete('/whatsapp/desconectar'),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['whatsapp-estado'] }),
  });
}

export function useActualizarTrigger() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (texto) => api.put('/whatsapp/trigger', { texto }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['whatsapp-estado'] }),
  });
}
